module.exports = __webpack_public_path__ + "static/18-4f2371d6648206d1638a33fc0cc18d52.jpg";